export default {
	logo: './static/img/ctrs_app_icon.png',
	title: '好生活供应商EDI',
	sendSms: false,
	titleLogo: './favicon.ico',
	mylogo: './static/img/ctrs_app_icon80.png'
}



// WEBPACK FOOTER //
// ./src/configs/index.js